module.exports = __webpack_public_path__ + "img/chr_ts_90_13.aebf5296.png";